import { render, staticRenderFns } from "./OnboardingStep2.vue?vue&type=template&id=7c08e3b6&scoped=true&lang=pug"
import script from "./OnboardingStep2.vue?vue&type=script&lang=js"
export * from "./OnboardingStep2.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStep2.vue?vue&type=style&index=0&id=7c08e3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08e3b6",
  null
  
)

export default component.exports